module.exports = __webpack_public_path__ + "img/p3-pic.af3bba9a.jpg";